import { useEffect } from 'react';
import useRaCostSetting from '../../../settings/hooks/useRaCostSetting';
import { GRAPH_VIEWS } from '../../Graph/graph.views';
import _ from 'lodash';

const useGraphViewsOptions = ({ graphView }) => {
  const raCost = useRaCostSetting();
  const graphViews = _.omit(
    GRAPH_VIEWS,
    raCost.isEnabled ? [] : [GRAPH_VIEWS.COST.key]
  );
  const graphViewsOptions = _.map(graphViews, currView => ({
    value: currView.key,
    displayValue: currView.name,
    isDisabled:
      currView.key === GRAPH_VIEWS.PERCENT.key && graphView.isOverlapping
  }));

  useEffect(() => {
    if (!graphViews[graphView.viewType.key])
      graphView.setViewType(GRAPH_VIEWS.PERCENT);
  }, [graphViews]);

  return graphViewsOptions;
};

export default useGraphViewsOptions;
